import { useEffect, useState } from "react";
import { Get, Post } from "../services/api";
import { toast } from "react-toastify";
import { formatDigit } from "./format.util";

const CompletedOrders = ({ side, refresh, socket }) => {
  const [orders, set_orders] = useState([]);

  useEffect(() => {
    if (!localStorage.getItem("jwtToken")) return;

    socket.emit(
      "get_orders",
      { side: side.toUpperCase(), status: "Completed" }, // same case as Zod expects
      (response) => {
        if (response?.status) {
          set_orders(response.orders);
        } else {
          console.log(response);
          toast.error("Failed to completed Orders");
        }
      }
    );
  }, [refresh, side]);

  return (
    <>
      <div className="tab-pane active" id="" role="tabpanel">
        <div className="userRecords-main ">
          <table className="table mb-0">
            <thead>
              <tr>
                <th className="f-left ng-binding">Pair</th>
                <th className="f-left ng-binding">Price</th>
                <th className="f-left ng-binding">Amount</th>
                <th className="f-left ng-binding">Total</th>
                <th className="f-left ng-binding">Date & Time</th>
              </tr>
            </thead>
            <tbody>
              {orders.length === 0 ? (
                <tr>
                  <td colSpan={4} style={{ textAlign: "center" }}>
                    No data available
                  </td>
                </tr>
              ) : (
                orders.map((e, i) => (
                  <tr className="ng-scope" key={i}>
                    <td className="f-left ng-binding ">{e.pair}</td>
                    <td className="f-left ng-binding ">
                      {formatDigit(e.price)}
                    </td>
                    <td
                      style={{
                        color: e.side === "SELL" ? "red " : "green ", // Added !important to force override
                      }}
                    >
                      {formatDigit(e.quantity)}
                    </td>
                    <td className="f-left ng-binding">
                      {formatDigit(e.trade_total)}
                    </td>
                    <td className="f-left ng-binding green">{e.created_at}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export { CompletedOrders };
